import styled, { useTheme } from "styled-components";

const Header: React.FC = () => {
  const theme = useTheme();

  return theme.assets.logo ? (
    <Container>
      <LogoImg src={theme.assets.logo} alt="Logo" />
    </Container>
  ) : null;
};

export default Header;

const LogoImg = styled.img`
  margin: auto;
  margin-top: 1.5vh;
  margin-bottom: 1.5vh;
  max-width: 11vw;
  @media (max-width: ${props => props.theme.breakpoints.lg}) {
  }
`;
const Container = styled.div`
  background: ${(props) => props.theme.gradients.headerBackground};
  display: flex;
  align-items: center;
  padding: 1rem;
  // min-height:5rem;
  @media (max-width: ${props => props.theme.breakpoints.lg}) {
    padding: 0.4rem 1rem;
  }
  @media (max-height: ${props => props.theme.breakpoints.xs}) {
    display: none;
  }
`;
